const STORAGE_KEY = "chatapp_premium_plan";
export const PREMIUM_PLAN_EVENT = "chatapp-premium-changed";

export function getPremiumPlan(userId) {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data?.userId !== userId) return null;
    return data;
  } catch {
    return null;
  }
}

export function isPremiumActive(userId) {
  return Boolean(getPremiumPlan(userId)?.planId);
}

export function activatePremiumPlan(userId, planId = "growth") {
  if (!userId) return null;
  const data = { userId, planId, activatedAt: Date.now() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  window.dispatchEvent(new CustomEvent(PREMIUM_PLAN_EVENT, { detail: data }));
  return data;
}

export function subscribePremiumPlan(callback) {
  const handler = (event) => callback(event.detail);
  window.addEventListener(PREMIUM_PLAN_EVENT, handler);
  return () => window.removeEventListener(PREMIUM_PLAN_EVENT, handler);
}
